let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("86snY")).then(() => parcelRequire('fha3R'));